import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {IrbAuthenticationComponent} from './irb-authentication.component';
import {IrbAuthenticationGuard} from '@irb/irb-authentication/irb-authentication.guard';
import {CommonModule} from "@angular/common";
import {IrbCommonModule} from "@irb-common/irb-common.module";

@NgModule({
  imports: [
    RouterModule.forChild([{ path: '', component: IrbAuthenticationComponent }]),
    CommonModule,
    IrbCommonModule,
  ],
  declarations: [IrbAuthenticationComponent],
    providers: [IrbAuthenticationGuard]
})
export class IrbAuthenticationModule { }
